import {
  Card,
  CardContent,
  FormControl,
  InputLabel,
  Select,
  Stack,
  Typography,
} from '@mui/material'
import { listFromKV } from '../../../Functions/ListItemGenerator'
import React from 'react'
import { useReaderContext } from '../../../Contexts/Modules/ReaderModule/ReaderModule'
import StepHeader from './StepHeader'
import { stackGap } from '../../../Constants&Theme/Spacing'

function Step3Apply() {
  const {
    containerSelectionModel,
    vesselSelectionModel,
    readerFunctionQuery,
    selectedFunc,
    setSelectedFunc,
  } = useReaderContext()
  return (
    <Card
      variant="outlined"
      sx={{ flex: 2 }}
    >
      <CardContent>
        <StepHeader
          step={3}
          name={'Apply'}
        />
        <Stack gap={stackGap.col}>
          <Typography variant="body2">
            Select a function to apply to the selection
          </Typography>
          <FormControl
            fullWidth
            size={'small'}
          >
            <InputLabel>Select Function</InputLabel>
            <Select
              disabled={
                containerSelectionModel.length + vesselSelectionModel.length ===
                0
              }
              value={selectedFunc}
              label={'Select Function'}
              onChange={(e) => setSelectedFunc(e.target.value)}
            >
              {listFromKV(
                // TODO: readerFunctionQuery.data ?? []
                // Once other items removed from list, can remove filter
                (readerFunctionQuery.data ?? []).filter((item) => {
                  const eitherSet = ['6']
                  const containerSet = ['10', '3']
                  const vesselSet = ['15']
                  let limitSet: string[] = []
                  if (
                    containerSelectionModel.length &&
                    vesselSelectionModel.length
                  )
                    limitSet = [...containerSet, ...vesselSet, ...eitherSet]
                  else if (containerSelectionModel.length) {
                    limitSet = [...containerSet, ...eitherSet]
                  } else if (vesselSelectionModel.length) {
                    limitSet = [...vesselSet, ...eitherSet]
                  }
                  return limitSet.includes(item.CodeValue as string)
                }),
                readerFunctionQuery.isLoading,
              )}
            </Select>
          </FormControl>
        </Stack>
      </CardContent>
    </Card>
  )
}

export default Step3Apply
